import type { CustomFormats } from 'react-intl'

export const intlFormats: CustomFormats = {
	number: {},
	date: {},
	time: {},
}
